import React, { CSSProperties, useRef } from 'react';
import { Input } from 'freemium-ui';
import { HexColorPicker } from 'react-colorful';
import { colorNameToHex } from 'shared/utils';
import { useOnClickOutside } from '../../../hooks';
import { StyledPicker } from './styles';

type InputProps = Omit<
  React.ComponentProps<typeof Input>,
  'onChange' | 'style'
>;

type ColorPickerProps = {
  color: string;
  onChange: (newColor: string) => void;
  style?: CSSProperties;
} & InputProps;

export const ColorPicker: React.FC<ColorPickerProps> = ({
  color,
  isErrored,
  label,
  errorText,
  isRequired = false,
  style,
  onChange,
  ...inputProps
}) => {
  const componentRef = useRef<HTMLDivElement>(null);

  const [pickerOpen, setPickerOpen] = React.useState<boolean>(false);

  useOnClickOutside(componentRef, () => {
    setPickerOpen(false);
  });

  const onPaletteClick = () => {
    if (!color.startsWith('#')) {
      const convertedColor = colorNameToHex(color);
      onChange(convertedColor === color ? '#000000' : convertedColor);
    }
    setPickerOpen(true);
  };

  return (
    <div ref={componentRef} style={style || {}}>
      <Input
        {...inputProps}
        startAdornment={
          <StyledPicker color={color}>
            <div onClick={onPaletteClick} className="color-preview" />
            <div className={`picker ${pickerOpen ? 'open' : ''}`}>
              <HexColorPicker color={color} onChange={onChange} />
            </div>
          </StyledPicker>
        }
        value={color}
        inputStyle={{
          minWidth: '110px',
        }}
        inline
        label={label}
        isRequired={isRequired}
        isErrored={isErrored}
        errorText={errorText}
        onChange={(e: any) => {
          onChange(e.target.value);
        }}
      />
    </div>
  );
};
